/**
 * A recusa da conclusão por identificação incompleta diz só o que falta (E177.F1.C03, GUS-253 item
 * 3): o servidor devolve os campos (`process_number`, `pasta`, `cpf_informado`), na ordem da tela, e
 * a mensagem não pede de novo o que a pessoa já preencheu. Sem campos, a frase de sempre.
 */
import { ptBR } from '@/i18n/pt-BR';

const t = ptBR.faltasDaIdentificacao;
const NOMES: Readonly<Record<string, string>> = t.campos;

export function mensagemDaIdentificacao(campos: readonly string[]): string {
  const nomes = campos.map((c) => NOMES[c]).filter((n): n is string => n !== undefined);
  if (nomes.length === 0) return ptBR.abertura.conferirEnvio.erroIdentificacao;
  const lista =
    nomes.length === 1 ? nomes[0] : `${nomes.slice(0, -1).join(', ')}${t.eFinal}${nomes.at(-1)}`;
  return t.mensagem.replace('{campos}', lista ?? '');
}
